import DailyMockCategoryFormPage from "./DailyMockCategoryFormPage";

export default function DailyMockCategoryAdd() {
  return (
    <DailyMockCategoryFormPage
      mode="add"
      pageTitle="Add Daily Mock Category"
      breadcrumbTitle="Add Daily Mock Category"
      successMessage="Daily mock category added successfully"
    />
  );
}
